import React from 'react';

import useDocumentTitle from '@hooks/useDocumentTitle';
import { DivWithShadowAlternate, SectionWrapperInner, SectionWrapperOuter } from '@styled';
import TrackPageView from '@tracking/TrackPageView';
import { SearchModeContext } from '../../../../../../algolia-search/js/context/searchContext';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import SectionHeader from '../../../_molecules/SectionHeader';
import RecentPropertiesInMyArea from '../../../_organisms/RecentPropertiesInMyArea';
import SearchPropertiesActive from '../../../searches/SearchPropertiesActive';
import PropertiesMobileSubnav from './PropertiesMobileSubnav';

const FindPropertiesPage = () => {
    useDocumentTitle('Find Properties');

    return (
        <ErrorHandler>
            <TrackPageView>
                <PropertiesMobileSubnav />

                <SectionWrapperOuter>
                    <SectionWrapperInner>
                        <SectionHeader
                            title="My ICSC Properties"
                            tutorialLabel="How to use the Networking Platform"
                            tutorialUrl="https://view.ceros.com/icsc/icsc-networking-platfrom/p/1"
                        />

                        <div className="mt-5">
                            <h3 className="font-weight-bold mb-3">Explore All Available Properties</h3>
                            <DivWithShadowAlternate className="p-3">
                                <SearchModeContext.Provider value={{ showFilters: false }}>
                                    <SearchPropertiesActive defaultViewType="card" displayMap updateSearchStateUrl />
                                </SearchModeContext.Provider>
                            </DivWithShadowAlternate>
                        </div>

                        <div className="mt-5">
                            <RecentPropertiesInMyArea />
                        </div>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};
export default FindPropertiesPage;
